import axios from 'axios';
import { toast } from 'react-toastify';

const API_URL = process.env.REACT_APP_API_URL;

const customHeaders = {
    'Content-Type': 'application/json'
};


export const getCountryQuery = async () => {
    try {
        const response = await axios.get(API_URL + `country`, { headers: customHeaders });
        return response;
    } catch (error) {
        console.error('Error fetching categories:', error);
        toast.error(error?.response?.data?.msg);
        throw error;
    }
};
